export default __webpack_public_path__ + "static/washer_b.a5f046e96bb084d9ba2445d1e16a94be.png";